import { render } from "./FormLastAppComponent.vue?vue&type=template&id=10a7ce24"
import script from "./FormLastAppComponent.vue?vue&type=script&lang=js"
export * from "./FormLastAppComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__